module.exports = __webpack_public_path__ + "static/img/13.612c8d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carrusel/13.png
// module id = 47o6
// module chunks = 5